import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../lib/utils";
import { useState, createContext, useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { IconMenu2, IconX } from "@tabler/icons-react";
const SidebarContext = createContext(undefined);
export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error("useSidebar must be used within a SidebarProvider");
    }
    return context;
};
export const SidebarProvider = ({ children, open: openProp, setOpen: setOpenProp, animate = true, }) => {
    const [openState, setOpenState] = useState(false);
    const [locked, setLocked] = useState(false);
    const [mode, setMode] = useState("sidebar");
    const open = openProp !== undefined ? openProp : openState;
    const setOpen = setOpenProp !== undefined ? setOpenProp : setOpenState;
    return (_jsx(SidebarContext.Provider, { value: { open, setOpen, animate: animate, locked, setLocked, mode, setMode }, children: children }));
};
export const Sidebar = ({ children, open, setOpen, animate, }) => {
    return (_jsx(SidebarProvider, { open: open, setOpen: setOpen, animate: animate, children: children }));
};
export const SidebarBody = (props) => {
    return (_jsxs(_Fragment, { children: [_jsx(DesktopSidebar, { ...props }), _jsx(MobileSidebar, { ...props })] }));
};
export const DesktopSidebar = ({ className, children, ...props }) => {
    const { open, setOpen, animate, locked } = useSidebar();
    return (_jsx(_Fragment, { children: _jsx(motion.div, { className: cn("h-full px-4 py-4 hidden md:flex md:flex-col bg-uw-surface-default border-r border-uw-border-default w-[300px] shrink-0 overflow-hidden", className), animate: {
                width: animate ? (open ? "300px" : "60px") : "300px",
            }, transition: {
                type: "spring",
                stiffness: 300,
                damping: 30
            }, onMouseEnter: () => !locked && setOpen(true), onMouseLeave: () => !locked && setOpen(false), ...props, children: children }) }));
};
export const MobileSidebar = ({ className, children, ...props }) => {
    const { open, setOpen } = useSidebar();
    return (_jsx(_Fragment, { children: _jsxs("div", { className: cn("h-16 px-4 py-4 flex flex-row md:hidden items-center justify-between bg-uw-surface-default border-b border-uw-border-default w-full"), ...props, children: [_jsx("div", { className: "flex-shrink-0 flex items-center", children: _jsx("h1", { className: "text-xl font-bold text-uw-text-primary", children: "Unwritten Admin" }) }), _jsx("div", { className: "flex justify-end z-20", children: _jsx(IconMenu2, { className: "text-uw-text-primary cursor-pointer", onClick: () => setOpen(!open) }) }), _jsx(AnimatePresence, { children: open && (_jsxs(motion.div, { initial: { x: "-100%", opacity: 0 }, animate: { x: 0, opacity: 1 }, exit: { x: "-100%", opacity: 0 }, transition: {
                            duration: 0.3,
                            ease: "easeInOut",
                        }, className: cn("fixed h-full w-full inset-0 bg-uw-surface-default p-10 z-[100] flex flex-col justify-between", className), children: [_jsx("div", { className: "absolute right-10 top-10 z-50 text-uw-text-primary cursor-pointer", onClick: () => setOpen(!open), children: _jsx(IconX, {}) }), children] })) })] }) }));
};
export const SidebarLink = ({ link, className, ...props }) => {
    const { open, animate } = useSidebar();
    return (_jsxs("div", { className: cn("group flex items-center justify-start gap-2 py-2 px-2 rounded-md transition-all duration-200 cursor-pointer", "text-uw-text-secondary hover:bg-uw-surface-elevated hover:text-uw-text-primary hover:shadow-sm", className), ...props, children: [_jsx("div", { className: "shrink-0 flex items-center justify-center w-5 h-5", children: link.icon }), _jsx(motion.span, { animate: {
                    display: animate ? (open ? "inline-block" : "none") : "inline-block",
                    opacity: animate ? (open ? 1 : 0) : 1,
                }, transition: {
                    duration: 0.2,
                    ease: "easeInOut"
                }, className: "text-sm whitespace-nowrap", children: link.label })] }));
};
//# sourceMappingURL=Sidebar.js.map